module.exports = __webpack_public_path__ + "static/media/bolha.641f31fa.svg";